// @ts-check
import React, { Component } from 'react';
import cx from 'classnames';
import Icon from 'shared/components/Icon';
import styles from './Reminders.module.scss';

const Reminder = ({
  canEdit,
  reminder,
  markReminderIncomplete,
  markReminderComplete,
  deleteReminder,
}) => (
  <li
    className={cx(styles.reminder, {
      [styles.asleep]: !reminder.awake,
      [styles.awake]: reminder.awake,
      [styles.completed]: reminder.completed,
    })}
  >
    <div data-spec-id={`reminder-${reminder.id}`}>
      <input
        name="completedCheckbox"
        className={styles.toggle}
        type="checkbox"
        checked={reminder.completed}
        onChange={() => {
          if (canEdit(reminder)) {
            return reminder.completed
              ? markReminderIncomplete(reminder.id)
              : markReminderComplete(reminder.id);
          }
          return null;
        }}
      />

      <div
        className={cx(styles.content, {
          [styles.completed]: reminder.completed,
        })}
      >
        <label
          className={cx(styles.title, {
            [styles.due]: reminder.awake,
          })}
        >
          <span>{reminder.remindOn}</span> - {reminder.note}
        </label>
        <label className={styles.subtitle}>
          created by {reminder.userName} ({reminder.userEntityName})
        </label>
      </div>

      <div className={styles.reminder_right}>
        <span
          className={cx({
            [styles.due]: reminder.awake,
            [styles.snoozed]: !reminder.awake,
          })}
        >
          {reminder.awake ? (
            <Icon name="bell" />
          ) : !reminder.completed ? (
            <Icon name="hour-glass" />
          ) : (
            <Icon name="checkmark" />
          )}
        </span>
        <span onClick={() => deleteReminder(reminder.id)} className="fake-link">
          Delete
        </span>
      </div>
    </div>
  </li>
);

const FILTERS = {
  ALL: 'ALL',
  DUE: 'DUE',
  ACTIVE: 'ACTIVE',
  COMPLETE: 'COMPLETE',
};

function filterReminders(filter, reminders) {
  switch (filter) {
    case FILTERS.DUE:
      return reminders.filter((r) => r.awake);
    case FILTERS.ACTIVE:
      return reminders.filter((r) => !r.completed);
    case FILTERS.COMPLETE:
      return reminders.filter((r) => r.completed);
    default:
      return reminders;
  }
}

class Reminders extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: FILTERS.ALL };
    this.changeFilter = this.changeFilter.bind(this);
  }

  changeFilter(newFilter) {
    this.setState({ filter: newFilter });
  }

  render() {
    const {
      reminders,
      editRemindersFromAdmin,
      editRemindersFromSender,
      editRemindersFromReceiver,
      markReminderComplete,
      markReminderIncomplete,
      deleteReminder,
    } = this.props;

    const canEdit = (reminder) =>
      (reminder.fromAdmin && editRemindersFromAdmin) ||
      (reminder.fromSender && editRemindersFromSender) ||
      (reminder.fromReceiver && editRemindersFromReceiver);

    const dueCount = reminders.filter((r) => r.awake).length;

    const visibleReminders = filterReminders(this.state.filter, reminders);

    return (
      <section className={styles.reminders}>
        <header className="flex items-center justify-around py-2">
          <span className={cx(styles.left, { [styles.due]: dueCount > 0 })}>
            {dueCount} Due
          </span>
          <ul className={styles.tabs}>
            <li>
              <span
                className={cx(styles.tab_text, {
                  [styles.selected]: this.state.filter === FILTERS.ALL,
                })}
                onClick={() => this.changeFilter(FILTERS.ALL)}
              >
                All
              </span>
            </li>
            <li>
              <span
                className={cx(styles.tab_text, {
                  [styles.selected]: this.state.filter === FILTERS.DUE,
                })}
                onClick={() => this.changeFilter(FILTERS.DUE)}
              >
                Due
              </span>
            </li>
            <li>
              <span
                className={cx(styles.tab_text, {
                  [styles.selected]: this.state.filter === FILTERS.ACTIVE,
                })}
                onClick={() => this.changeFilter(FILTERS.ACTIVE)}
              >
                Active
              </span>
            </li>
            <li>
              <span
                className={cx(styles.tab_text, {
                  [styles.selected]: this.state.filter === FILTERS.COMPLETE,
                })}
                onClick={() => this.changeFilter(FILTERS.COMPLETE)}
              >
                Complete
              </span>
            </li>
          </ul>
          <span className="_flex-placeholder" />
        </header>
        {visibleReminders.length > 0 ? (
          <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
            {visibleReminders.map((reminder) => (
              <Reminder
                key={reminder.id}
                canEdit={canEdit}
                reminder={reminder}
                markReminderComplete={markReminderComplete}
                markReminderIncomplete={markReminderIncomplete}
                deleteReminder={deleteReminder}
              />
            ))}
          </ul>
        ) : (
          <p>No reminders</p>
        )}
      </section>
    );
  }
}

export default Reminders;
